import type { FastifyInstance } from 'fastify'
import { UsersController } from './users.controller'
import { UsersService } from './users.service'
import { UsersRepository } from './users.repository'
import { db } from '../../core/database/firebase'
import { redisClient } from '../../core/redis/client.js'

export async function usersModule(app: FastifyInstance) {
  const usersRepository = new UsersRepository(db)
  const usersService = new UsersService(usersRepository, redisClient)
  const usersController = new UsersController(usersService)

  await import('./users.routes').then(({ usersRoutes }) =>
    usersRoutes(app, usersController),
  )
}
